class Step {
    constructor({ id, uid, ref, title = null, content = null, choices = null }) {
        this.id = id;
        this.uid = uid;
        this.ref = ref;
        this.title = title;
        this.content = content;
        this.choices = choices;
    }
}

export default Step;
